import { Skeleton } from '@/shared/components';

const SkeletonItem = () => (
  <div className="flex w-full items-start gap-[1.6rem] px-[1.6rem] py-[1.2rem]">
    <Skeleton variant="avatar" className="w-[3.8rem] shrink-0" />

    <div className="flex grow flex-col gap-[0.6rem] pt-[0.2rem]">
      <Skeleton variant="small" className="w-[12rem] h-[1.4rem]" />
      <Skeleton variant="small" className="w-[8rem] h-[1.2rem]" />
    </div>

    <Skeleton variant="small" className="w-[8rem] h-[1.4rem] mt-[0.3rem]" />
  </div>
);

export const HistoryOperationsListSkeleton = () => (
  <div className="flex flex-col gap-[0.8rem]">
    <Skeleton variant="small" className="mx-[1.6rem] w-[10rem] h-[1.4rem]" />

    <div className="flex flex-col">
      {Array.from({ length: 10 }).map((_, index) => (
        <SkeletonItem key={index} />
      ))}
    </div>
  </div>
);
